import React from 'react';
import { useNavigate } from 'react-router-dom';

export const StreakDisplay = ({ streak = 0, streakDays = [], graceDayAvailable = false, animateIn }) => {
  const navigate = useNavigate();

  return (
    <section 
      className={`mb-10 transition-all duration-700 ${animateIn ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}
      style={{ transitionDelay: '0.5s' }}
    >
      <h2 
        className="text-xs tracking-[0.2em] mb-6 text-center"
        style={{ fontFamily: 'Jost, sans-serif', color: '#C9A84C' }}
      >
        YOUR JOURNEY
      </h2>
      
      <div className="flex justify-center gap-3 mb-4">
        {streakDays.map((day, idx) => (
          <div key={`streak-day-${idx}`} className="flex flex-col items-center">
            <div 
              className={`rounded-full transition-all duration-500 ${day.isToday ? 'w-5 h-5' : 'w-3 h-3'}`}
              style={{ 
                background: day.isCompleted ? '#C9A84C' : '#EAE4DC',
                boxShadow: day.isToday ? '0 0 0 3px rgba(201,168,76,0.3), 0 0 15px rgba(201,168,76,0.3)' : 'none',
                animationDelay: `${idx * 0.1}s`,
              }}
            />
            <span 
              className="text-xs mt-2"
              style={{ color: day.isToday ? '#C9A84C' : '#A3A0AE', fontFamily: 'Jost, sans-serif' }}
            >
              {day.day}
            </span>
          </div>
        ))}
      </div>
      
      <p className="text-center text-sm" style={{ color: '#C9A84C', fontFamily: 'Jost, sans-serif' }}>
        {streak} day streak
      </p>
      
      {graceDayAvailable && (
        <p className="text-center text-xs italic mt-1" style={{ color: '#A9756B', fontFamily: 'Playfair Display, serif' }}>
          ✦ Grace day available
        </p>
      )}
      
      <button
        onClick={() => navigate('/journal')}
        className="mx-auto mt-4 flex items-center gap-2 text-xs transition-all duration-300 hover:gap-3"
        style={{ color: '#8A8798' }}
        data-testid="view-journal-link"
      >
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
          <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/>
          <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/>
        </svg>
        View full journal
      </button>
    </section>
  );
};
